import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Tooltip } from 'app-components';
// types

export interface IColumns {
  titleId: string;
  key: string;
  render?: (item: any) => React.ReactNode;
  tooltipId?: string;
  inputRequired?: boolean;
}

export interface ITableProps {
  hasBorders?: boolean;
  showAllHeaders?: boolean;
  classNamesStr?: string;
  data: {}[];
  columns: IColumns[];
  onSelectRow?: (rowIdx)=>{}
}

const Table = (props: ITableProps) => {
    const {
        data,
        columns,
        hasBorders = false,
        showAllHeaders = false,
        classNamesStr,
        onSelectRow = ()=>{}
    } = props;
    const intl = useIntl();
    const tableHeader = (
        <thead>
            <tr>
                {columns.map(column => {
                    return (
                        <th key={column.key} scope="col" data-testid={column.key}>
                            {column.tooltipId ? (
                                <>
                                    <Tooltip
                                        { ...{
                                            id: column.titleId,
                                            contentId:column.titleId,
                                            content:column.tooltipId,
                                            index:column.key
                                        }}
                                    />
                                    {
                                        column.inputRequired ? <span className='required--true'></span> : ''
                                    }
                                </>

                            ) : (
                                <span>
                                    {intl.formatMessage({ id: column.titleId })}
                                </span>
                            )}
                        </th>
                    );
                })}
            </tr>
        </thead>
    );

    const tableBody = (
        <tbody>
            {
                data.map((row: any, rowIdx: number) => (
                    <tr key={rowIdx} onClick = { () =>{ typeof onSelectRow === 'function' && onSelectRow(rowIdx); } } className={`${row?.isSelected ?  '_selected' : '_unselected'}`}>
                        {
                            columns.map((column, colIdx) => {
                                return (
                                    <td key={colIdx} data-testid={colIdx}>
                                        {
                                            column.render &&
                      column.render(row)
                                        }
                                        {
                                            !column.render &&
                        <span>{row[column.key]}</span>
                                        }
                                    </td>
                                );
                            }
                            )}
                    </tr>
                ))
            }
        </tbody>
    );

    const tableClasses = clsx({
        'usa-table gi-table': true,
        'gi-table-show-all-headers': showAllHeaders,
        'usa-table--borderless': !hasBorders,
        [`${classNamesStr}`]: !!classNamesStr
    });

    return (
        <div className={'gi-table__responsive'}>
            <table className={tableClasses}>
                {tableHeader}
                {tableBody}
            </table>
        </div>
    );
};

Table.propTypes = {
    hasBorders: PropTypes.bool,
    classNamesStr: PropTypes.string,
    data: PropTypes.any.isRequired,
    columns: PropTypes.arrayOf(PropTypes.shape({
        titleId: PropTypes.string.isRequired,
        key: PropTypes.string.isRequired,
        render: PropTypes.func,
        tooltipId: PropTypes.string,
    }))
};

Table.defaultProps = {
    hasBorders: false,
    showAllHeaders: false
};

export default Table;
